/* Bull Ring Fabrics: the bag never lets the quantity go past what is in stock (bag page and mini bag). Added 2026-10-23 for Abid.
   Loaded from snippets/brf-bag-aurora.liquid. Stock per bag line comes from sections/brf-cart-max.liquid (fetched fresh).
   - At the stock limit the + button greys out and does nothing (before, it counted up and jumped back a few seconds later).
   - A typed number above the limit is set back to the limit straight away.
   - Under 15 left: "Only 7 metres left" shows under the quantity box.
   2026-10-24 (Abid): a typed quantity is now saved by this script, not the theme. Typing 46 when we have 11 puts all 11 in
   the bag and says "All 11 metres we have are in your bag" under the box. Before, the box showed 11 but the bag kept the old
   quantity, and pressing + afterwards counted on from the old quantity. While a typed quantity is being saved, +/- wait. */
(function () {
  if (window.__brfCartStock) return; window.__brfCartStock = 1;
  var doc = document, LOW = 15;
  var maxes = []; /* per bag line (index 0 = line 1): number, or null for no limit */
  var busy = false, again = false, t = null, lastSig = '';

  var css = doc.createElement('style');
  css.textContent =
    '.brf-at-max{opacity:.3!important;cursor:not-allowed!important}' +
    '.brf-left{flex-basis:100%;margin:6px 0 0;font-size:12.5px;line-height:1.35;font-weight:600;color:#C4343B}' +
    '.brf-left.is-max{display:flex;align-items:center;gap:6px;color:#1D1D1F}' +
    '.brf-left.is-max::before{content:"";flex:0 0 auto;width:6px;height:6px;border-radius:50%;background:#E8A33D}' +
    '.brf-left.is-nudge{animation:brfLeftNudge .5s cubic-bezier(.3,1.6,.4,1)}' +
    '@keyframes brfLeftNudge{30%{transform:translateX(-4px)}60%{transform:translateX(3px)}100%{transform:none}}' +
    '@media (prefers-reduced-motion:reduce){.brf-left.is-nudge{animation:none}}';
  (doc.head || doc.documentElement).appendChild(css);

  function rows() {
    /* every quantity box in the bag with its line number: bag page inputs carry data-line; mini bag rows are in cart order */
    var out = [];
    [].forEach.call(doc.querySelectorAll('.quantity-selector__value[data-line]'), function (inp) {
      if (inp.closest('#mini-cart')) return;
      out.push({ inp: inp, line: parseInt(inp.getAttribute('data-line'), 10) });
    });
    [].forEach.call(doc.querySelectorAll('#mini-cart .mini-cart__line-item'), function (row, i) {
      var inp = row.querySelector('.quantity-selector__value'); if (inp) out.push({ inp: inp, line: i + 1 });
    });
    return out;
  }
  function lineOf(inp) {
    var r = rows(); for (var i = 0; i < r.length; i++) if (r[i].inp === inp) return r[i].line;
    return parseInt(inp.getAttribute('data-line'), 10) || null;
  }
  function unit(box, n) {
    var scope = box.closest('.line-item, .mini-cart__line-item') || box.parentNode;
    var u = scope.querySelector('.brf-qty-unit, .brf-unit, .brf-mc__per'), s = u ? u.textContent.toLowerCase() : '';
    if (s.indexOf('metre') > -1) return n === 1 ? 'metre' : 'metres';
    if (s.indexOf('roll') > -1) return n === 1 ? 'roll' : 'rolls';
    return '';
  }
  /* q = quantity in the box; at or over the stock it says the whole stock is in the bag */
  function note(box, max, q, nudge) {
    var host = box.parentNode, el = host.querySelector(':scope > .brf-left'), full = max != null && q >= max;
    if (max == null || max <= 0 || (max >= LOW && !full && !nudge)) { if (el) el.parentNode.removeChild(el); return; }
    if (!el) { el = doc.createElement('p'); el.className = 'brf-left'; el.setAttribute('aria-live', 'polite'); host.appendChild(el); }
    var u = unit(box, max), txt;
    if (full) txt = max === 1 ? 'The last one is in your bag' : 'All ' + max + (u ? ' ' + u : '') + ' we have are in your bag';
    else txt = 'Only ' + max + (u ? ' ' + u : '') + (max >= LOW ? ' in stock' : ' left');
    if (el.textContent !== txt) el.textContent = txt;
    el.classList.toggle('is-max', full);
    if (nudge) { el.classList.remove('is-nudge'); void el.offsetWidth; el.classList.add('is-nudge'); }
  }
  function apply() {
    rows().forEach(function (r) {
      var max = maxes[r.line - 1];
      var box = r.inp.closest('.quantity-selector'); if (!box) return;
      var plus = box.querySelector('[data-action="increase-quantity"]');
      if (max == null) { r.inp.removeAttribute('data-brf-cap'); if (plus) { plus.classList.remove('brf-at-max'); plus.removeAttribute('aria-disabled'); } note(box, null); return; }
      r.inp.setAttribute('data-brf-cap', max); r.inp.max = max;
      var q = parseInt(r.inp.value, 10) || 0, at = q >= max;
      if (plus) { plus.classList.toggle('brf-at-max', at); if (at) plus.setAttribute('aria-disabled', 'true'); else plus.removeAttribute('aria-disabled'); }
      note(box, max, q);
    });
  }
  function refresh() {
    if (busy) { again = true; return; }
    if (!rows().length) { maxes = []; return; }
    busy = true;
    Promise.all([
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      fetch('/?section_id=brf-cart-max', { credentials: 'same-origin' }).then(function (r) { return r.text(); })
    ]).then(function (res) {
      var m = /<script[^>]*data-brf-cart-max[^>]*>([\s\S]*?)<\/script>/.exec(res[1]), map = {};
      try { map = JSON.parse(m ? m[1] : '{}'); } catch (e) { map = {}; }
      maxes = (res[0].items || []).map(function (it) { return map.hasOwnProperty(it.key) ? map[it.key] : null; });
      apply();
    }).catch(function () {}).then(function () { busy = false; if (again) { again = false; soon(); } });
  }
  function soon() { clearTimeout(t); t = setTimeout(refresh, 200); }

  function capOf(el) {
    var box = el.closest('.quantity-selector'), inp = box && box.querySelector('.quantity-selector__value');
    var c = inp && inp.getAttribute('data-brf-cap');
    return { box: box, inp: inp, max: c == null || c === '' ? null : parseInt(c, 10) };
  }

  /* save a typed quantity (capped at the stock) ourselves, so the bag always ends up with what the box shows */
  function commit(inp) {
    if (!inp || inp.__brfSaving) return;
    var box = inp.closest('.quantity-selector'); if (!box) return;
    var cur = parseInt(inp.getAttribute('data-current-value'), 10);
    if (isNaN(cur)) cur = parseInt(inp.defaultValue, 10) || 0;
    var v = parseInt(String(inp.value || '').replace(/\D/g, ''), 10);
    if (isNaN(v)) { inp.value = cur; return; }
    var c = capOf(inp), max = c.max;
    if (max != null && v > max) v = max;
    inp.value = v;
    if (max != null && v >= max) note(box, max, v, true);
    if (v === cur) return;
    var line = lineOf(inp); if (!line) return;
    inp.__brfSaving = true; box.classList.add('brf-saving');
    doc.dispatchEvent(new CustomEvent('theme:loading:start'));
    fetch(((window.routes && routes.cartChangeUrl) || '/cart/change') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: v })
    }).then(function () {
      if (doc.body.classList.contains('template-cart') || (window.theme && theme.pageType === 'cart')) { location.reload(); return; }
      inp.__brfSaving = false; box.classList.remove('brf-saving');
      doc.dispatchEvent(new CustomEvent('theme:loading:end'));
      doc.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    }).catch(function () {
      inp.__brfSaving = false; box.classList.remove('brf-saving');
      doc.dispatchEvent(new CustomEvent('theme:loading:end'));
      inp.value = cur;
    });
  }
  function isBagBox(el) {
    return el && el.matches && el.matches('.quantity-selector:not(.quantity-selector--product) .quantity-selector__value');
  }

  /* + / - : wait while a typed quantity is saving; + at the limit does nothing */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]'); if (!b) return;
    var c = capOf(b); if (!c.inp) return;
    if (c.inp.__brfSaving) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    /* a typed number that was not saved yet (no blur in between): save that instead of counting on from the old quantity */
    var cur = c.inp.getAttribute('data-current-value');
    if (b.matches('.quantity-selector__button') && cur != null && String(c.inp.value) !== cur && isBagBox(c.inp)) {
      e.preventDefault(); e.stopImmediatePropagation(); commit(c.inp); return;
    }
    if (!b.matches('[data-action="increase-quantity"]') || c.max == null) return;
    var q = parseInt(c.inp.value, 10) || 0, next = parseInt(b.getAttribute('data-quantity'), 10) || q + 1;
    if (q >= c.max || next > c.max) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (q > c.max) c.inp.value = c.max;
      b.classList.add('brf-at-max'); b.setAttribute('aria-disabled', 'true');
      note(c.box, c.max, Math.max(q, c.max), true);
    }
  }, true);
  /* typed quantity above the limit: shown as the limit at once */
  doc.addEventListener('input', function (e) {
    var inp = e.target; if (!inp.matches || !inp.matches('.quantity-selector__value[data-brf-cap]')) return;
    var max = parseInt(inp.getAttribute('data-brf-cap'), 10), v = parseInt(inp.value, 10);
    if (!isNaN(max) && v > max) { inp.value = max; note(inp.closest('.quantity-selector'), max, max, true); }
  }, true);
  /* typed quantity saved on change (blur) or Enter, by commit() and not by the theme */
  doc.addEventListener('change', function (e) {
    if (!isBagBox(e.target)) return;
    e.stopImmediatePropagation(); commit(e.target);
  }, true);
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !isBagBox(e.target)) return;
    e.preventDefault(); commit(e.target);
  }, true);

  /* the bag redraws after every change: follow it (our own notes don't count) */
  function watch() {
    var targets = [doc.querySelector('#mini-cart'), doc.querySelector('#shopify-section-cart-template'), doc.querySelector('.template-cart [data-section-type="cart"]')];
    var mo = new MutationObserver(function () {
      /* only when the bag lines or their quantities really changed (timers and our own notes also touch the page) */
      var sig = rows().map(function (r) { return r.line + ':' + r.inp.value; }).join(',');
      if (sig === lastSig) return; lastSig = sig; apply(); soon();
    });
    targets.forEach(function (el) { if (el && !el.__brfCs) { el.__brfCs = 1; mo.observe(el, { childList: true, subtree: true }); } });
    soon();
  }
  ['cart:refresh', 'cart:rerendered', 'cart:updated'].forEach(function (n) { doc.addEventListener(n, soon); doc.documentElement.addEventListener(n, soon); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', watch); else watch();
  window.addEventListener('load', watch);
})();
